<template>
    <div class="animated fadeIn">
        <b-row class="justify-content-md-center">
            <b-col xl="12" md="12" xs="12">
                <b-card no-body class="billing-overview">
                    <b-card-header>
                        <span>Payment Settings</span>

                        <button v-if="typeAccount == 'HYBRID_TERMS' && paymentsAchNotVerified.length == 0 && paymentsAchVerified.length == 0" @click="showACHaccount()" class="btn btn-link">Add ACH Account</button>
                    </b-card-header>
                     <b-card-body>
                        <div class="bordered-area ach-area" v-if="typeAccount == 'HYBRID_TERMS' && (paymentsAchNotVerified.length > 0 || paymentsAchVerified.length > 0)">
                            <strong v-if="paymentsAchVerified.length > 0">Added ACH Accounts</strong>

                            <div v-if="paymentsAchVerified.length" class="list-payments list-payments-settings">
                                <div class="credit-cards-list">
                                    <div v-for="(card, index) in paymentsAchVerified" v-bind:key="index" class="credit-card-wrapper">
                                        <div :class="['credit-card']">
                                            <span class="ach-logo">ACH</span>
                                            <span class="credit-card-number">{{card.accountAlias}} </span>
                                        </div>

                                        <div @click="achRemove(card.accountId)" class="remove-button action-element">
                                            <img src="../../assets/img/new-trash-icon.svg" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <strong v-if="paymentsAchNotVerified.length > 0">Verification</strong>

                            <div v-if="paymentsAchNotVerified.length > 0" class="verification-info">You will recieve two bank transfers from Stripe to the account you have entered while adding an ACH Account. <br />Enter those values in the text fields next to the appropriate account in Payment Settings</div>

                            <div v-if="paymentsAchNotVerified.length" class="list-payments list-payments-settings">
                                <div class="credit-cards-list">
                                    <div v-for="(card, index) in paymentsAchNotVerified" v-bind:key="index" class="credit-card-wrapper">
                                        <div :class="['credit-card']">
                                            <span class="ach-logo">ACH</span>
                                            <span class="credit-card-number">{{card.accountAlias}} </span>
                                            <span class="credit-card-nickname">{{card.accountStatus.replace("_", " ").toLowerCase()}}</span>
                                        </div>

                                        <div v-if="card.accountStatus == 'IN_VERIFICATION'" class="ach-verification">
                                            <div class="pin-1">
                                                <input type="number" class="ach-pin" placeholder="$ value 1" v-model="card.pin1">
                                            </div>

                                            <div class="pin-2">
                                                <input type="number" class="ach-pin" placeholder="$ value 2" v-model="card.pin2">
                                            </div>

                                            <div class="button-verifi">
                                                <button class="btn btn-primary action-element" @click="confirmACHaccount(card.accountId, card.pin1, card.pin2)">Confirm</button>
                                            </div>
                                        </div>
                                        <div v-else class="ach-verification-status">
                                            {{card.accountStatus.replace('_', ' ').toLowerCase()}}
                                        </div>
                                        <div class="ach-verification-remove">
                                            <a @click="deleteACH(card.accountId)">Remove</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button @click="showACHaccount()" class="btn btn-primary add-ach-btn action-element">
                                <img src="../../assets/img/add-ach-icon.svg" alt="">Add ACH Account</button>
                        </div>
                        <div class="bordered-area" v-if="typeAccount != 'OFFLINE_BILLING'">
                            <h3 class="title-area">Credit Card</h3>
                            <div class="list-payments list-payments-settings">
                                <div v-if="cardsList.length" class="credit-cards-list">
                                    <div v-for="(card, index) in cardsList" v-bind:key="index" class="credit-card-wrapper">
                                        <div :class="['credit-card']">
                                            <img class="credit-card-image" :src="require('../../assets/img/' + card.cardImg)" alt="credit-card-logo" />
                                            <span class="credit-card-number">{{card.cardDesc}} </span>
                                            <span class="credit-card-nickname">{{card.nickName}}</span>
                                        </div>
                                        <div v-if="card.defcard != '1' || typeAccount == 'HYBRID_TERMS'" class="remove-button action-element" @click="removeCreditCard(card.creditCardId, card.cardDesc)">
                                            <img src="../../assets/img/new-trash-icon.svg" alt="">
                                        </div>
                                        <div v-else class="remove-button removing-disabled">
                                            <img src="../../assets/img/new-trash-icon.svg" alt="">
                                            <div class="removing-disabled-tooltip">This credit card is set as the Default Payment Method.
                                                In order to remove this Credit Card, a different Credit Card
                                                needs to be set as the default payment method.</div>
                                        </div>
                                        <div v-if="typeAccount != 'HYBRID_TERMS'" class="set-default-box">
                                            <a class="set-default action-element" @click="setAsDefault(card.creditCardId)" v-if="card.defcard != '1'">Set as default</a>
                                            <a class="default" v-else>Default Payment Method</a>
                                        </div>
                                    </div>
                                </div>
                                <button @click="showModalAddCard" class="btn btn-primary add-payment action-element">
                                    <img src="../../assets/img/add-card-icon.svg" alt=""> Add Credit Card
                                </button>
                            </div>
                        </div>

                        <div class="bordered-area" v-if="typeAccount == 'PREPAID'">
                            <h3 class="title-area">Auto-Refill</h3>

                            <div class="auto-funds-wrapper">
                                <c-switch class="mx-1" color="success" variant="3d" label v-bind="labelIcon" :disabled="autoFundsEnabled == true" v-model="autoFundsEnabled"/>

                                <div :class="['add-row', autoFundsEnabled ? '' : 'gray-out']">
                                    <div class="first-row">
                                        <span>Refill to</span>
                                        <div class="wrapper-input">
                                            <input type="text" class="form-control" id="addValue" name="addValue" :disabled="autoFundsEnabled == false" v-model="autoFundsSettins.maxBalance" @keyup="maxbalanceKeyUp()">
                                        </div>
                                    </div>
                                    <div class="second-row">
                                        <span>when balance is lower than</span>
                                        <div class="wrapper-input">
                                            <input type="text" class="form-control" id="lowerThen" name="lowerThen" :disabled="autoFundsEnabled == false" v-model="autoFundsSettins.minBalance" @keyup="minbalanceKeyUp()">
                                        </div>
                                    </div>
                                </div>

                                <div class="wrong-dollar" v-if="validationMaxBalance || validationMinBalance">Please enter a valid dollar amount. Examples inclide 10, 10.10, 10.1</div>
                                <div class="wrong-diffrence" v-if="validationDiffrent">Difference between <strong>“Refill to “</strong> and <strong>“lower than”</strong> should be 1 or more</div>

                                <div :class="['select-card', autoFundsEnabled ? '' : 'gray-out']">
                                    <div class="card" v-if="hasDefCard > 0">
                                        <div class="fts-radio">
                                            <input type="radio" name="auto-funds" v-model="autoFundsSettins.creditCard" :disabled="autoFundsEnabled == false" id="ccDefault" :value="defCard">
                                            <label for="ccDefault"></label>
                                        </div>
                                        <label for="ccDefault" class="value">
                                            <span>Use default card <strong>{{defCardName}} - {{defCardDesc}}</strong> for Auto-Refill</span>
                                        </label>
                                    </div>
                                    <div class="card" v-for="(item, index) in cardsList" v-if="item.creditCardId != defCard" v-bind:key="index">
                                        <div class="fts-radio">
                                            <input type="radio" name="auto-funds" v-model="autoFundsSettins.creditCard" :disabled="autoFundsEnabled == false" :id="'cc'+ index" :value="item.creditCardId">
                                            <label :for="'cc'+ index"></label>
                                        </div>
                                        <label :for="'cc'+ index" class="value">
                                            <span>Use Credit card <strong>{{item.nickName}} - {{item.cardDesc}}</strong> for Auto-Refill</span>
                                        </label>
                                    </div>
                                </div>
                                <div :class="['buttons-row']">
                                    <button class="btn btn-success action-element" :disabled="validationMaxBalance == true || validationMinBalance == true || validationDiffrent == true" @click="saveAutoFunds()">Save changes</button>
                                </div>
                            </div>
                        </div>
                     </b-card-body>
                </b-card>
            </b-col>
        </b-row>

        <b-modal id="add-credit-card" size="md" class="user-settings" centered title="Add Credit Card" ref="add-credit-card" hide-footer hide-header centered>
            <div class="user-details">
                <div class="add-credit-card-header">
                    <h3>Add Credit Card</h3>
                    <i class="fa fa-close" @click="$bvModal.hide('add-credit-card')"></i>
                </div>
                <b-row>
                    <b-col md="12">
                        <b-form-group>
                            <label for="cname">Card Nickname</label>
                            <b-form-input type="text" id="cname" v-model="newCard.cardNick" placeholder="Work" v-validate="'required'" data-vv-as="card nick" name="cname"></b-form-input>
                            <span v-show="errors && errors.has('cname')" class="validate-warning">{{ errors.first('cname') }}</span>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <div id="card" ref="card"></div>
                    </b-col>

                    <b-col md="12">
                        <b-form-group>
                            <label>Billing Address</label>
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group>
                            <label for="address">Address</label>
                            <b-form-input
                                type="text"
                                id="address"
                                placeholder="ex. 23 High St, Apt 5"
                                v-model="newCard.customer.address"
                                v-validate="'required'"
                                name="address"
                            ></b-form-input>
                            <span v-show="errors && errors.has('address')" class="validate-warning">{{ errors.first('address') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="city">City</label>
                            <b-form-input type="text" id="city" placeholder="ex. New York" v-model="newCard.customer.city" v-validate="'required'" name="city"></b-form-input>
                            <span v-show="errors && errors.has('city')" class="validate-warning">{{ errors.first('city') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group :class="['no-mt', errors && errors.has('state-user') ? 'error-field' : '']" v-if="country == 'United States'">
                            <label for="state-user">State</label>
                            <select class="form-control" name="state-user" v-model="newCard.customer.state" v-validate="'required'" data-vv-as="state">
                                <option v-for="state in stateList" v-bind:key="state.abbreviation" :value="state.abbreviation">{{ state.name }}</option>
                            </select>
                            <span v-show="errors && errors.has('state-user')" class="validate-warning">{{ errors.first('state-user') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group v-if="country == 'United States'" :class="[errors && errors.has('pcode-user') ? 'error-field' : '']">
                            <label for="pcode-user">Postal Code</label>
                            <input type="text" class="form-control" name="pcode-user" v-model="newCard.customer.zip" v-validate="{required: true, regex: /^[0-9]{5}(-[0-9]{4})?$/}" data-vv-as="postal code">
                            <span v-show="errors && errors.has('pcode-user')" class="validate-warning">{{ errors.first('pcode-user') }}</span>
                        </b-form-group>

                        <b-form-group v-if="country == 'Canada'" :class="[errors && errors.has('pcode-user') ? 'error-field' : '']">
                            <label for="pcode-user">Postal Code</label>
                            <input type="text" class="form-control" name="pcode-user" v-model="newCard.customer.zip" v-validate="{required: true, regex: /^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[- ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}$/}" data-vv-as="postal code">
                            <span v-show="errors && errors.has('pcode-user')" class="validate-warning">{{ errors.first('pcode-user') }}</span>
                        </b-form-group>

                        <b-form-group v-if="country != 'United States' && country != 'Canada'" :class="[errors && errors.has('pcode-user') ? 'error-field' : '']">
                            <label for="pcode-user">Postal Code</label>
                            <input type="text" class="form-control" name="pcode-user" v-model="newCard.customer.zip" v-validate="{required: true}" data-vv-as="postal code">
                            <span v-show="errors && errors.has('pcode-user')" class="validate-warning">{{ errors.first('pcode-user') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group :class="['no-mt', errors && errors.has('contries-user') ? 'error-field' : '']">
                            <label for="country-user">Country</label>
                            <select class="form-control" name="contries-user" v-model="country" v-validate="'required'" data-vv-as="country">
                                <option v-for="country in countries" v-bind:key="country.name" :name="country.name">{{ country.name }}</option>
                            </select>
                            <span v-show="errors && errors.has('contries-user')" class="validate-warning">{{ errors.first('contries-user') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group class="switch-inline-label">
                            <div>
                                <c-switch class="mx-1" color="success" defaultChecked variant="3d" label v-bind="labelIcon" v-model="newCard.default"/>
                                <label>Set As Default Payment Method</label>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <footer id="add-credit-card___BV_modal_footer_" class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="$bvModal.hide('add-credit-card')">Cancel</button>
                <button type="button" class="btn btn-primary action-element" :disabled="blockAddButton" @click="addCreditCard">OK</button>
            </footer>
        </b-modal>

        <b-modal hide-footer id="add-balance" size="md" class="user-settings" centered title="Add Funds">
            <div class="user-details">
                <b-row>
                    <b-col md="6">
                        <b-form-group>
                            <b-form-input type="text" id="bvalue" placeholder="Enter $"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <label>From existing Credit card</label>
                    </b-col>

                    <b-col md="12">
                        <div class="credit-card-list">
                            <div class="card-item">
                                <div class="icon-select">
                                    <i class="fa fa-check-circle" aria-hidden="true"></i>
                                </div>
                                <div class="card-wrap">
                                    <div class="card-img">
                                        <img src="../../assets/img/payment.png" alt>
                                    </div>

                                    <div class="card-number">
                                        <span>4056 … … 1282</span>
                                    </div>

                                    <span>(work)</span>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12" class="buttons-payment-wrap">
                        <b-button class="action-element" v-b-modal.add-credit-card variant="outline-dark">Add Credit Card</b-button>

                        <b-button class="action-element" variant="success">Add to balance</b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal id="remove-credit-card" size="md" class="delete-cc" centered ref="delete-credit-card" hide-header hide-footer>
            <i class="fa fa-close" @click="hideDeleteCard()"></i>
            <img src="./../../assets/img/delete-cc-icon.svg" alt="">
            <h3>Delete Credit Card</h3>
            <p>The Credit Card ({{cardNicknameToDelete}}) will be deleted. Do you want to continue?</p>
            <div class="control-bar">
                <button @click="hideDeleteCard" type="button" class="btn btn-light">Cancel</button>
                <button @click="deleteCard" type="button" class="btn btn-danger action-element">Yes, delete</button>
            </div>
        </b-modal>

        <b-modal size="md" ref="add-ach-account" id="addAchAccount" centered hide-header hide-footer>
            <div class="ach-account-wrap">
                <div class="ach-account-header">
                    <h3>Add ACH Account</h3>

                    <button @click="hideACHaccount()">
                        <i class="fa fa-close"></i>
                    </button>
                </div>

                <div class="ach-account-body">
                    <span>Only USA accounts can be added</span>

                    <div class="ach-account-error" v-if="newACHaccount.errorStatus">{{newACHaccount.errorMessage}}</div>

                    <b-form-group id="ach-alias" label="Account Alias" label-for="ach-aliass" invalid-feedback="This field is required">
                        <b-form-input type="text" id="ach-alias" placeholder="Enter a nickname for this account" v-model="newACHaccount.alias" v-validate="'required'" name="ach-alias" data-vv-as="Account Alias"></b-form-input>
                        <span v-show="errors && errors.has('ach-alias')" class="validate-warning">{{ errors.first('ach-alias') }}</span>
                    </b-form-group>

                    <div class="inline-fieldset-2-1">
                        <b-form-group id="ach-country" label="Country" label-for="ach-country" invalid-feedback="This field is required">
                            <b-form-input disabled type="text" id="ach-country" placeholder="Country" v-model="newACHaccount.country" v-validate="'required'" name="ach-country" data-vv-as="Country"></b-form-input>
                            <span v-show="errors && errors.has('ach-country')" class="validate-warning">{{ errors.first('ach-country') }}</span>
                        </b-form-group>

                        <b-form-group id="ach-currency" label="Currency" label-for="ach-currency" invalid-feedback="This field is required">
                            <b-form-input disabled type="text" id="ach-currency" placeholder="Currency" v-model="newACHaccount.currency" v-validate="'required'" name="ach-currency" data-vv-as="Currency"></b-form-input>
                            <span v-show="errors && errors.has('ach-currency')" class="validate-warning">{{ errors.first('ach-currency') }}</span>
                        </b-form-group>
                    </div>

                    <b-form-group id="ach-routing-number" label="Routing Number *" label-for="ach-routing-number" invalid-feedback="This field is required">
                        <b-form-input type="text" id="ach-routing-number" placeholder="Enter a name you will recognize" v-model="newACHaccount.routing_number" v-validate="'required'" name="ach-routing-number" data-vv-as="Routing Number"></b-form-input>
                        <span v-show="errors && errors.has('ach-routing-number')" class="validate-warning">{{ errors.first('ach-routing-number') }}</span>
                    </b-form-group>

                    <b-form-group id="ach-account-number" label="Account Number *" label-for="ach-account-number" invalid-feedback="This field is required">
                        <b-form-input type="text" id="ach-account-number" placeholder="Enter Your Account Number" v-model="newACHaccount.account_number" v-validate="'required'" name="ach-account-number" data-vv-as="Account Number"></b-form-input>
                        <span v-show="errors && errors.has('ach-account-number')" class="validate-warning">{{ errors.first('ach-account-number') }}</span>
                    </b-form-group>

                    <b-form-group id="ach-account-holder-type" label="Account Holder Type *" label-for="ach-account-holder-type" invalid-feedback="This field is required">
                        <b-form-select type="text" id="ach-account-holder-type" placeholder="Enter Your Holder Type" v-model="newACHaccount.account_holder_type" :options="[{value:'individual', text: 'Individual'}, {value:'company', text: 'Company'}]" v-validate="'required'" name="ach-account-holder-type" data-vv-as="Holder Type"></b-form-select>
                        <span v-show="errors && errors.has('ach-account-holder-type')" class="validate-warning">{{ errors.first('ach-account-holder-type') }}</span>
                    </b-form-group>

                    <div class="inline-fieldset-1-1">
                        <b-form-group id="ach-fname" label="First Name *" label-for="ach-fname" invalid-feedback="This field is required">
                            <b-form-input type="text" id="ach-fname" placeholder="Account Holder Name" v-model="newACHaccount.fname" v-validate="'required'" name="ach-fname" data-vv-as="First Name"></b-form-input>
                            <span v-show="errors && errors.has('ach-fname')" class="validate-warning">{{ errors.first('ach-fname') }}</span>
                        </b-form-group>

                        <b-form-group id="ach-lname" label="Last Name *" label-for="ach-lname" invalid-feedback="This field is required">
                            <b-form-input type="text" id="ach-lname" placeholder="Account Holder Last Name" v-model="newACHaccount.lname" v-validate="'required'" name="ach-lname" data-vv-as="Last Name"></b-form-input>
                            <span v-show="errors && errors.has('ach-lname')" class="validate-warning">{{ errors.first('ach-lname') }}</span>
                        </b-form-group>
                    </div>
                </div>

                <div class="ach-account-buttons">
                    <button class="btn btn-light" @click="hideACHaccount()">Cancel</button>
                    <button class="btn btn-primary action-element" @click="validateACHaccount()">Next</button>
                </div>

                <div v-if="achValidationAccount" class="ach-validation">
                    <div class="sk-wave">
                        <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal size="md" ref="summary-ach-account" id="summaryAchAccount" centered hide-header hide-footer>
            <div class="ach-account-wrap">
                <div class="ach-account-header">
                    <h3>Add ACH Account</h3>

                    <button @click="hideACHsummary()">
                        <i class="fa fa-close"></i>
                    </button>
                </div>

                <div class="ach-account-body">
                    <div class="ach-data">
                        <div class="field">
                            <span class="label">Account Alias:</span>
                            <strong class="value">{{newACHaccount.alias}}</strong>
                        </div>

                        <div class="field">
                            <span class="label">Country:</span>
                            <strong class="value">{{newACHaccount.country}}</strong>
                        </div>

                        <div class="field field-x05">
                            <span class="label">Currency:</span>
                            <strong class="value">{{newACHaccount.currency}}</strong>
                        </div>

                        <div class="field">
                            <span class="label">Routing Number:</span>
                            <strong class="value">{{newACHaccount.routing_number}}</strong>
                        </div>

                        <div class="field field-x2">
                            <span class="label">Account Number:</span>
                            <strong class="value">{{newACHaccount.account_number}}</strong>
                        </div>

                        <div class="field">
                            <span class="label">Account Holder Name:</span>
                            <strong class="value">{{newACHaccount.fname}} {{newACHaccount.lname}}</strong>
                        </div>

                        <div class="field field-x2">
                            <span class="label">Account Holder Type:</span>
                            <strong class="value">{{newACHaccount.account_holder_type}}</strong>
                        </div>
                    </div>
                    <div class="ach-error">
                        <h3>ATTENTION</h3>
                        <p>After adding the ACH Account it needs to be verified. The verifying process can take up from 2 to 5 business days. Please make sure that the entered data is correct. You have only three tries of verification.</p>
                    </div>

                    <div class="ach-warning">
                        <h3>VERIFICATION</h3>
                        <p>The verification process consists of two steps:<p>
                        <p>1. You will recieve two bank transfers from Stripe to your account. </p>
                        <p>2. Enter those values in the text fields next to the appropriate account in Payment Settings</p>
                    </div>

                    <span>This information will be available to you in Payment Settings, and in your mailbox.</span>
                </div>

                <div class="ach-account-buttons">
                    <button class="btn btn-light" @click="backACHaccount()">Back</button>
                    <button class="btn btn-primary action-element" @click="addACHaccount()">Add & Verify</button>
                </div>

                <div v-if="achValidationAccount" class="ach-validation">
                    <div class="sk-wave">
                        <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import Axios from 'axios'
import { Switch as cSwitch } from "@coreui/vue";
import { Card, createToken } from 'vue-stripe-elements'
import VeeValidate from "vee-validate";
import globalStore from '../../variables'
import VueCookies from 'vue-cookies';
import {loadStripe} from '@stripe/stripe-js';
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)

const veeValidateConfig = {};

Vue.use(VeeValidate, veeValidateConfig);

export default {
    name: "Billing",
    components: {
        cSwitch,
        Card
    },
    data() {
        return {
            paymentsAchVerified: [],
            paymentsAchNotVerified: [],
            paymentsMethods: {
                bankAccount: [],
                creditCard: [],
            },
            verificationAccount: [],
            achValidationAccount: false,
            newACHaccount: {
                alias: '',
                country: 'US',
                currency: 'usd',
                routing_number: '',
                account_number: '',
                account_holder_type: 'individual',
                fname: '',
                lname: '',
                account_type: '',
                errorStatus: false,
                errorMessage: '',
            },
            bankAccountToken: '',
            bankAccountAlias: '',
            bankAccount: {
                country: '',
                currency: '',
                routing_number: '',
                account_number: '',
                account_holder_name: '',
                account_holder_type: '',
            },
            validationDiffrent: false,
            validationMaxBalance: false,
            validationMinBalance: false,
            complete: false,
            stripeOptions: {
                hidePostalCode: true
            },
            labelIcon: {
                dataOn: "\u2713",
                dataOff: "\u2715"
            },
            card: undefined,
            stripe: undefined,
            elements: undefined,
            optionsCard: undefined,
            newCard: {
                cardNick: '',
                cardToken: null,
                default: false,
                customer: {
                    address: '',
                    city: '',
                    state: '',
                    zip: '',
                }
            },
            country: 'United States',
            countries: [],
            cardsList: [],
            stateList: [
                {
                    "name": "Alabama",
                    "abbreviation": "AL"
                },
                {
                    "name": "Alaska",
                    "abbreviation": "AK"
                },
                {
                    "name": "American Samoa",
                    "abbreviation": "AS"
                },
                {
                    "name": "Arizona",
                    "abbreviation": "AZ"
                },
                {
                    "name": "Arkansas",
                    "abbreviation": "AR"
                },
                {
                    "name": "California",
                    "abbreviation": "CA"
                },
                {
                    "name": "Colorado",
                    "abbreviation": "CO"
                },
                {
                    "name": "Connecticut",
                    "abbreviation": "CT"
                },
                {
                    "name": "Delaware",
                    "abbreviation": "DE"
                },
                {
                    "name": "District Of Columbia",
                    "abbreviation": "DC"
                },
                {
                    "name": "Federated States Of Micronesia",
                    "abbreviation": "FM"
                },
                {
                    "name": "Florida",
                    "abbreviation": "FL"
                },
                {
                    "name": "Georgia",
                    "abbreviation": "GA"
                },
                {
                    "name": "Guam",
                    "abbreviation": "GU"
                },
                {
                    "name": "Hawaii",
                    "abbreviation": "HI"
                },
                {
                    "name": "Idaho",
                    "abbreviation": "ID"
                },
                {
                    "name": "Illinois",
                    "abbreviation": "IL"
                },
                {
                    "name": "Indiana",
                    "abbreviation": "IN"
                },
                {
                    "name": "Iowa",
                    "abbreviation": "IA"
                },
                {
                    "name": "Kansas",
                    "abbreviation": "KS"
                },
                {
                    "name": "Kentucky",
                    "abbreviation": "KY"
                },
                {
                    "name": "Louisiana",
                    "abbreviation": "LA"
                },
                {
                    "name": "Maine",
                    "abbreviation": "ME"
                },
                {
                    "name": "Marshall Islands",
                    "abbreviation": "MH"
                },
                {
                    "name": "Maryland",
                    "abbreviation": "MD"
                },
                {
                    "name": "Massachusetts",
                    "abbreviation": "MA"
                },
                {
                    "name": "Michigan",
                    "abbreviation": "MI"
                },
                {
                    "name": "Minnesota",
                    "abbreviation": "MN"
                },
                {
                    "name": "Mississippi",
                    "abbreviation": "MS"
                },
                {
                    "name": "Missouri",
                    "abbreviation": "MO"
                },
                {
                    "name": "Montana",
                    "abbreviation": "MT"
                },
                {
                    "name": "Nebraska",
                    "abbreviation": "NE"
                },
                {
                    "name": "Nevada",
                    "abbreviation": "NV"
                },
                {
                    "name": "New Hampshire",
                    "abbreviation": "NH"
                },
                {
                    "name": "New Jersey",
                    "abbreviation": "NJ"
                },
                {
                    "name": "New Mexico",
                    "abbreviation": "NM"
                },
                {
                    "name": "New York",
                    "abbreviation": "NY"
                },
                {
                    "name": "North Carolina",
                    "abbreviation": "NC"
                },
                {
                    "name": "North Dakota",
                    "abbreviation": "ND"
                },
                {
                    "name": "Northern Mariana Islands",
                    "abbreviation": "MP"
                },
                {
                    "name": "Ohio",
                    "abbreviation": "OH"
                },
                {
                    "name": "Oklahoma",
                    "abbreviation": "OK"
                },
                {
                    "name": "Oregon",
                    "abbreviation": "OR"
                },
                {
                    "name": "Palau",
                    "abbreviation": "PW"
                },
                {
                    "name": "Pennsylvania",
                    "abbreviation": "PA"
                },
                {
                    "name": "Puerto Rico",
                    "abbreviation": "PR"
                },
                {
                    "name": "Rhode Island",
                    "abbreviation": "RI"
                },
                {
                    "name": "South Carolina",
                    "abbreviation": "SC"
                },
                {
                    "name": "South Dakota",
                    "abbreviation": "SD"
                },
                {
                    "name": "Tennessee",
                    "abbreviation": "TN"
                },
                {
                    "name": "Texas",
                    "abbreviation": "TX"
                },
                {
                    "name": "Utah",
                    "abbreviation": "UT"
                },
                {
                    "name": "Vermont",
                    "abbreviation": "VT"
                },
                {
                    "name": "Virgin Islands",
                    "abbreviation": "VI"
                },
                {
                    "name": "Virginia",
                    "abbreviation": "VA"
                },
                {
                    "name": "Washington",
                    "abbreviation": "WA"
                },
                {
                    "name": "West Virginia",
                    "abbreviation": "WV"
                },
                {
                    "name": "Wisconsin",
                    "abbreviation": "WI"
                },
                {
                    "name": "Wyoming",
                    "abbreviation": "WY"
                }
            ],
            cardNumberToDelete: null,
            cardNicknameToDelete: null,
            typeAccount: this.$session.get('token') ? this.$session.get('typeAccount') : this.$cookies.get('typeAccount'),
            companyId: this.$cookies.get('companyId'),
            autoFundsEnabled: false,
            lowerMarker: '',
            higherMarker: '',
            selectedPaymentOptions: 'cc2',
            autoFundsSettins: {
                minBalance: 0,
                maxBalance: 0,
                creditCardId: 0,
                companyDiscount: 0
            },
            hasDefCard: 0,
            defCard: 0,
            defCardDesc: '',
            defCardName: '',
            firstCard: null,
            blockAddButton: false,
            typingTimer: null,
            textVariable: '',
        };
    },
    methods: {
        achRemove(id) {
            Axios.delete(`${globalStore.data.restApiUrl}/ach-payments/${id}`)
                .then(response => {
                    console.log(response)
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Remove success',
                        text: 'This account was removed.',
                        duration: 5000,
                    });
                    this.getPayment();
                    this.refreshTopUpWidget()
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Wrong remove bank account',
                        text: 'Something was wrong during remove bank account. Please contact with support.',
                        duration: 5000,
                    });
                    return false
                })
        },
        confirmACHaccount(id, pin1, pin2) {
            if (pin1 != '' && pin2 != '') {
                let dataToSend = {
                    'accountId': id,
                    'deposit1Value': pin1 * 100,
                    'deposit2Value': pin2 * 100,
                }
                Axios.post(`${globalStore.data.restApiUrl}/ach-payments/verify`, dataToSend)
                    .then(response => {
                        console.log(response)
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Verification success',
                            text: 'ACH Account has been verified successfully.',
                            duration: 5000,
                        });
                        this.getPayment();
                        this.refreshTopUpWidget()
                    }).catch(error => {
                        if (error.response.data.errors.length > 0) {
                            error.response.data.errors.forEach(error => {
                                if (error.errorCode == 'SimonPaymentException') {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'Verification error',
                                        text: error.errorMessage,
                                        duration: 5000,
                                    });
                                    return false
                                } else {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'Verification error',
                                        text: 'Something went wrong during adding bank account. Please contact with support.',
                                        duration: 5000,
                                    });
                                    return false
                                }
                            })
                        }
                    })
            } else {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Empty Pin fields',
                    text: 'Pin fields was empty, first you must type pin code.',
                    duration: 5000,
                });
                return false
            }
        },
        getPayment() {
            Axios.get(`${globalStore.data.restApiUrl}/ach-payments`)
                .then(response => {
                    this.paymentsAchVerified = []
                    this.paymentsAchNotVerified = []
                    for (let ach of response.data) {
                        if (ach.accountStatus == 'VERIFIED') {
                            this.paymentsAchVerified.push(ach)
                        } else {
                            this.paymentsAchNotVerified.push(ach)
                        }
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Wrong getting payment',
                        text: 'Something was wrong during getting payment methods. Please contact with support.',
                        duration: 5000,
                    });
                    return false
                })
        },
        addACHaccount() {
            this.achValidationAccount = true;

            let accountVariables = {
                accountToken: this.newACHaccount.bankAccountToken,
                accountNumber: this.newACHaccount.account_number,
                accountAlias: this.newACHaccount.alias
            };

            Axios.post(`${globalStore.data.restApiUrl}/ach-payments`, accountVariables)
                .then(response => {
                    this.achValidationAccount = false;
                    this.getPayment();
                    this.$refs['summary-ach-account'].hide();

                    this.newACHaccount = {
                        alias: '',
                        country: 'US',
                        currency: 'usd',
                        routing_number: '',
                        account_number: '',
                        account_holder_type: 'individual',
                        fname: '',
                        lname: '',
                        account_type: '',
                        errorStatus: false,
                        errorMessage: '',
                    };
                })
                .catch(error => {
                    this.achValidationAccount = false;

                    if (error.response.data.errors.length > 0) {
                        error.response.data.errors.forEach(error => {
                            if (error.errorCode == 'SimonPaymentException') {
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Wrong add bank account',
                                    text: error.errorMessage,
                                    duration: 5000,
                                });
                                return false
                            } else {
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Wrong add bank account',
                                    text: 'Something was wrong during add bank account. Please contact with support.',
                                    duration: 5000,
                                });
                                return false
                            }
                        })
                    }

                    console.log(error)
                })
        },
        validateACHaccount() {
            let tempThis = this;
            this.$validator.validateAll().then(resultValidation => {
                if (resultValidation) {
                    this.achValidationAccount = true;

                    let achStripeData = {
                        country: this.newACHaccount.country,
                        currency: this.newACHaccount.currency,
                        account_number: this.newACHaccount.account_number,
                        routing_number: this.newACHaccount.routing_number,
                        account_holder_name: this.newACHaccount.fname + ' ' + this.newACHaccount.lname,
                        account_holder_type: this.newACHaccount.account_holder_type,
                    };

                    tempThis.stripe.createToken('bank_account', achStripeData)
                            .then(response => {
                                this.achValidationAccount = false;
                                if (response.error) {
                                    this.newACHaccount.errorStatus = true;
                                    this.newACHaccount.errorMessage = response.error.message;
                                } else {
                                    this.newACHaccount.bankAccountToken = response.token;
                                    this.$refs['add-ach-account'].hide();
                                    this.$refs['summary-ach-account'].show();
                                }
                            }).catch(error => {
                                this.achValidationAccount = false;
                                console.log(error)
                            });
                }
            });
        },
        hideACHsummary() {
            this.$refs['summary-ach-account'].hide();
        },
        backACHaccount() {
            this.$refs['summary-ach-account'].hide();
            this.$refs['add-ach-account'].show();
        },
        hideACHaccount() {
            this.$refs['add-ach-account'].hide();
        },
        showACHaccount() {
            this.$refs['add-ach-account'].show();
        },
        sendStripeRequest() {
            this.stripe.createToken('bank_account', this.bankAccount)
                    .then(response => {
                        console.log(response.token, response);

                        this.bankAccountToken = response.token;

                        let accountVariables = {
                            accountToken: response.token,
                            accountNumber: this.bankAccount.account_number,
                            accountAlias: this.bankAccountAlias
                        }

                        Axios.post(`${globalStore.data.restApiUrl}/ach-payments`, accountVariables)
                            .then(response => {
                                console.log(response)
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    })
        },
        saveAutoFunds() {
            if(this.autoFundsSettins.maxBalance <= 0 || Number (this.autoFundsSettins.maxBalance) <= Number (this.autoFundsSettins.minBalance)) {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Wrong refill amount',
                    text: 'Refill amount must be higher than balance and higher than zero.',
                    duration: 5000,
                });
                return false
            }
            let objDataToSave = {
                minBalance: this.autoFundsSettins.minBalance,
                maxBalance: this.autoFundsSettins.maxBalance,
                autoCharge: this.autoFundsEnabled
            }

            if (this.autoFundsSettins.creditCard != 0) {
                objDataToSave.creditCardId = this.autoFundsSettins.creditCard
            } else {
                objDataToSave.creditCardId = 0
            }

            Axios.patch(`${globalStore.data.restApiUrl}/billing-ng/wallet?companyId=${this.companyId}`, objDataToSave)
                .then(response => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Auto-Funds setting',
                        text: 'Auto-Funds setting was updated successfully',
                        duration: 5000,
                    });
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Auto-Funds setting',
                        text: 'Auto-Funds setting wasn\'t updated',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        getWalletSettings() {
            Axios.get(`${globalStore.data.restApiUrl}/billing-ng/wallet-info?companyId=${this.companyId}`)
                .then(response => {
                    this.autoFundsSettins.minBalance = response.data.minBalance.toFixed(2)
                    this.autoFundsSettins.maxBalance = response.data.maxBalance.toFixed(2)
                    this.autoFundsEnabled = response.data.autoCharge

                    if (response.data.creditCard != null) {
                        this.autoFundsSettins.creditCard = response.data.creditCard.creditCardId
                    } else {
                        if (this.hasDefCard) {
                            this.autoFundsSettins.creditCard = this.defCard;
                        }
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting walet info',
                        text: 'Getting walet info error',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        deleteCard() {
            Axios.delete(globalStore.data.restApiUrl + '/billing/card/' + this.cardNumberToDelete)
                .then(response => {
                    this.newCard = {
                        cardNick: '',
                        cardToken: null,
                        default: false,
                        customer: {
                            address: '',
                            city: '',
                            state: '',
                            zip: ''
                        }
                    }
                    this.country = 'United States'
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Delete Credit Card success',
                        text: 'Credit Card Deleted Successfully',
                        duration: 5000,
                    });
                    this.$refs['delete-credit-card'].hide()
                    this.getCreditCard()
                    this.refreshTopUpWidget()
                }).catch(error => {
                    this.newCard = {
                        cardNick: '',
                        cardToken: null,
                        default: false,
                        customer: {
                            address: '',
                            city: '',
                            state: '',
                            zip: ''
                        }
                    }
                    this.country = 'United States'
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Delete Credit Card error',
                        text: 'Error Deleting Credit Card - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                    this.$refs['delete-credit-card'].hide()
                })
        },
        removeCreditCard(id, nickname) {
            this.cardNumberToDelete = id;
            this.cardNicknameToDelete = nickname;
            this.$refs['delete-credit-card'].show();
        },
        hideDeleteCard() {
            this.$refs['delete-credit-card'].hide()
        },
        showModalAddCard() {
            this.$refs['add-credit-card'].show()
            let tempThis = this;

            setTimeout(function () {
                tempThis.card.mount(document.querySelector("#card"))
            }, 100);
        },
        maxbalanceKeyUp() {
            let regEx = /^[1-9]\d*(?:\.\d{0,2})?$/;
            if (this.autoFundsSettins.maxBalance.length > 0) {
                if (regEx.test(this.autoFundsSettins.maxBalance)) {
                    if (this.autoFundsSettins.maxBalance - this.autoFundsSettins.minBalance >= 1) {
                        this.validationMaxBalance = false;
                        this.validationDiffrent = false;
                    } else {
                        this.validationMaxBalance = false;
                        this.validationDiffrent = true;
                    }
                } else {
                    this.validationMinBalance = false;
                    this.validationMaxBalance = true;
                }
            } else {
                this.validationMaxBalance = false;
                this.validationDiffrent = false;
            }
        },
        minbalanceKeyUp() {
            let regEx = /^[1-9]\d*(?:\.\d{0,2})?$/;
            if (this.autoFundsSettins.minBalance.length > 0) {
                if (regEx.test(this.autoFundsSettins.minBalance)) {
                    if (this.autoFundsSettins.maxBalance - this.autoFundsSettins.minBalance >= 1) {
                        this.validationMinBalance = false;
                        this.validationDiffrent = false;
                    } else {
                        this.validationMinBalance = false;
                        this.validationDiffrent = true;
                    }
                } else {
                    this.validationMinBalance = false;
                    this.validationMinBalance = true;
                }
            } else {
                this.validationMinBalance = false;
                this.validationDiffrent = false;
            }
        },
        addCreditCard () {
            this.$validator.validateAll().then(resultValidation => {
                if (resultValidation) {
                    this.blockAddButton = true
                    let nameCard = this.newCard.cardNick;

                    this.stripe.createToken(this.card, {name: nameCard})
                        .then(result => {
                            this.newCard.cardToken = result.token.id
                            this.saveCreditCard()
                        }).catch(error => {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'Credit Card Error',
                                text: 'Error Validating Credit Card - Contact Support',
                                duration: 5000,
                            });
                            this.blockAddButton = false
                            console.log(result.error)
                            return false;
                        });
                }
            })
        },
        async initStripe() {

            let kindTheme = document.querySelector("body").classList.contains('dark-theme') ? true : false;
            
            if (globalStore.data.runTimeEnviroment != 'portalsimoniot') {
                this.stripe = await loadStripe('pk_test_l3Wo58GDAaNzjOR1YAFq679e000GwfPacx');
                console.log('pk_test_l3Wo58GDAaNzjOR1YAFq679e000GwfPacx');
            } else {
                this.stripe = await loadStripe('pk_live_68se4hupVyIP7VhdiJCSY0Hw00Cqs6Aifg');
                console.log('pk_live_68se4hupVyIP7VhdiJCSY0Hw00Cqs6Aifg');
            }
            this.elements = this.stripe.elements();

            if (kindTheme == true) {
                this.optionsCard = {
                    hidePostalCode: true,
                    metadata: {
                        companyId: 1
                    },
                    style: {
                        base: {
                            color: '#fff',
                            '::placeholder': {
                                color: 'rgba(255, 255, 255, .6)'
                            },
                        }
                    }
                }
            } else {
                this.optionsCard = {
                    hidePostalCode: true,
                    metadata: {
                        companyId: 1
                    }
                }
            }

            this.card = this.elements.create("card", this.optionsCard);
        },
        getCustomerData() {
            Axios.get(globalStore.data.restApiUrl + "/account").then(response => {
                this.newCard.companyId = response.data.companyId
            })
        },
        saveCreditCard() {
            var tempThis = this;
            Axios.post(globalStore.data.restApiUrl + "/billing/card", this.newCard).then(response => {
                this.blockAddButton = false
                tempThis.getCreditCard();
                this.hideAddCardModal();
                this.refreshTopUpWidget()
            })
            .catch(error => {
                this.blockAddButton = false
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Card not added',
                    text: 'An error has occured during adding credit card, please contact support',
                    duration: 5000,
                });
                console.log(error)
            })
        },
        getCreditCard() {
            let first = true;
            Axios.get(globalStore.data.restApiUrl + '/account/credit-card')
                .then(response => {
                    this.cardsList = [];
                    let parse = response.data
                    for (let card of parse) {
                        let cardDescTemp = card.card_desc
                        let cardImg = card.card_desc.substring(0, card.card_desc.indexOf('*'));
                        let cardNum = card.card_desc.substring(card.card_desc.indexOf('*') +5 , card.card_desc.length);
                        if (cardImg == 'Visa') {
                            cardImg = 'Visa-icon.svg'
                        } else if (cardImg == 'MasterCard') {
                            cardImg = 'MasterCard-icon.svg'
                        } else if (cardImg == 'Discover') {
                            cardImg = 'Discover-icon.svg'
                        } else if (cardImg == 'JCB') {
                            cardImg = 'JCB-icon.svg'
                        } else if (cardImg == 'American Express') {
                            cardImg = 'American Express-icon.svg'
                        } else if (cardImg == 'Diners Club') {
                            cardImg = 'dinersclub-icon.svg'
                        } else if (cardImg == 'UnionPay') {
                            cardImg = 'unionpay-icon.svg'
                        } else {
                            cardImg = 'defaultCard-icon.svg'
                        }

                        this.cardsList.push(
                            {
                                cardDesc: cardDescTemp,
                                creditCardId: card.creditCardId,
                                cardImg: cardImg,
                                cardNumber: cardNum,
                                exp_date: card.exp_date,
                                defcard: card.defcard,
                                nickName: card.nickName
                            }
                        )

                        if (card.defcard != 0) {
                            this.defCard = card.creditCardId;
                            this.defCardDesc = cardDescTemp;
                            this.defCardName = card.nickName;
                            this.hasDefCard++;
                        }

                        if (first) {
                            this.autoFundsSettins.creditCard = card.creditCardId;
                            first = false;
                        }
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Error',
                        text: 'Error Retrieving Credit Card Details - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        hideAddCardModal() {
            this.$refs['add-credit-card'].hide()
        },
        setAsDefault(id) {
            let dataToSend = {
                companyId: this.$cookies.get('companyId')
            }
            Axios.patch( globalStore.data.restApiUrl + '/account/defcard-new/' + id, dataToSend)
            .then( result => {
                this.getCreditCard();
                this.refreshTopUpWidget()
                this.$notify({
                    type: 'success',
                    group: 'notification',
                    title: 'Default card set',
                    text: 'New default credit card has been set.',
                    duration: 5000,
                });
            })
            .catch( error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Error during setting default card',
                    text: 'Something went wrong during setting credit card as default. Please, contact support.',
                    duration: 5000,
                });
            })
        },
        deleteACH(id) {
            Axios.delete(globalStore.data.restApiUrl + '/ach-payments/' + id + '?companyId=' + this.companyId)
                .then(response => {
                    this.getPayment()
                    this.refreshTopUpWidget()
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Error during removing Bank Account',
                        text: 'Something went wrong during removing Bank Account. Please, contact support.',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        refreshTopUpWidget() {
            globalStore.data.EventBus.$emit('refreshTopUpWidget', true)
        }
    },
    created() {
        this.getCustomerData();
        this.getCreditCard();
        if (this.$session.get('token')) {
            if (this.$session.get('typeAccount') == 'HYBRID_TERMS') {
                this.getPayment();
            }
        } else {
            if (this.$cookies.get('typeAccount') == 'HYBRID_TERMS') {
                this.getPayment();
            }
        }
    },
    mounted() {
        this.initStripe();


        if (this.$session.get('typeAccount') == 'PREPAID') {
            this.typeAccount = this.$session.get('typeAccount');
            this.companyId = this.$session.get('companyId')
            this.getWalletSettings();
        }

        if (this.$cookies.get('typeAccount') == 'PREPAID') {
            this.getWalletSettings()
        }


        this.countries = [
            {"name": "United States", "code": "US"},
            {"name": "Afghanistan", "code": "AF"},
            {"name": "Åland Islands", "code": "AX"},
            {"name": "Albania", "code": "AL"},
            {"name": "Algeria", "code": "DZ"},
            {"name": "American Samoa", "code": "AS"},
            {"name": "AndorrA", "code": "AD"},
            {"name": "Angola", "code": "AO"},
            {"name": "Anguilla", "code": "AI"},
            {"name": "Antarctica", "code": "AQ"},
            {"name": "Antigua and Barbuda", "code": "AG"},
            {"name": "Argentina", "code": "AR"},
            {"name": "Armenia", "code": "AM"},
            {"name": "Aruba", "code": "AW"},
            {"name": "Australia", "code": "AU"},
            {"name": "Austria", "code": "AT"},
            {"name": "Azerbaijan", "code": "AZ"},
            {"name": "Bahamas", "code": "BS"},
            {"name": "Bahrain", "code": "BH"},
            {"name": "Bangladesh", "code": "BD"},
            {"name": "Barbados", "code": "BB"},
            {"name": "Belarus", "code": "BY"},
            {"name": "Belgium", "code": "BE"},
            {"name": "Belize", "code": "BZ"},
            {"name": "Benin", "code": "BJ"},
            {"name": "Bermuda", "code": "BM"},
            {"name": "Bhutan", "code": "BT"},
            {"name": "Bolivia", "code": "BO"},
            {"name": "Bosnia and Herzegovina", "code": "BA"},
            {"name": "Botswana", "code": "BW"},
            {"name": "Bouvet Island", "code": "BV"},
            {"name": "Brazil", "code": "BR"},
            {"name": "British Indian Ocean Territory", "code": "IO"},
            {"name": "Brunei Darussalam", "code": "BN"},
            {"name": "Bulgaria", "code": "BG"},
            {"name": "Burkina Faso", "code": "BF"},
            {"name": "Burundi", "code": "BI"},
            {"name": "Cambodia", "code": "KH"},
            {"name": "Cameroon", "code": "CM"},
            {"name": "Canada", "code": "CA"},
            {"name": "Cape Verde", "code": "CV"},
            {"name": "Cayman Islands", "code": "KY"},
            {"name": "Central African Republic", "code": "CF"},
            {"name": "Chad", "code": "TD"},
            {"name": "Chile", "code": "CL"},
            {"name": "China", "code": "CN"},
            {"name": "Christmas Island", "code": "CX"},
            {"name": "Cocos (Keeling) Islands", "code": "CC"},
            {"name": "Colombia", "code": "CO"},
            {"name": "Comoros", "code": "KM"},
            {"name": "Congo", "code": "CG"},
            {"name": "Congo, The Democratic Republic of the", "code": "CD"},
            {"name": "Cook Islands", "code": "CK"},
            {"name": "Costa Rica", "code": "CR"},
            {"name": "Cote D'Ivoire", "code": "CI"},
            {"name": "Croatia", "code": "HR"},
            {"name": "Cuba", "code": "CU"},
            {"name": "Cyprus", "code": "CY"},
            {"name": "Czechia", "code": "CZ"},
            {"name": "Denmark", "code": "DK"},
            {"name": "Djibouti", "code": "DJ"},
            {"name": "Dominica", "code": "DM"},
            {"name": "Dominican Republic", "code": "DO"},
            {"name": "Ecuador", "code": "EC"},
            {"name": "Egypt", "code": "EG"},
            {"name": "El Salvador", "code": "SV"},
            {"name": "Equatorial Guinea", "code": "GQ"},
            {"name": "Eritrea", "code": "ER"},
            {"name": "Estonia", "code": "EE"},
            {"name": "Ethiopia", "code": "ET"},
            {"name": "Falkland Islands (Malvinas)", "code": "FK"},
            {"name": "Faroe Islands", "code": "FO"},
            {"name": "Fiji", "code": "FJ"},
            {"name": "Finland", "code": "FI"},
            {"name": "France", "code": "FR"},
            {"name": "French Guiana", "code": "GF"},
            {"name": "French Polynesia", "code": "PF"},
            {"name": "French Southern Territories", "code": "TF"},
            {"name": "Gabon", "code": "GA"},
            {"name": "Gambia", "code": "GM"},
            {"name": "Georgia", "code": "GE"},
            {"name": "Germany", "code": "DE"},
            {"name": "Ghana", "code": "GH"},
            {"name": "Gibraltar", "code": "GI"},
            {"name": "Greece", "code": "GR"},
            {"name": "Greenland", "code": "GL"},
            {"name": "Grenada", "code": "GD"},
            {"name": "Guadeloupe", "code": "GP"},
            {"name": "Guam", "code": "GU"},
            {"name": "Guatemala", "code": "GT"},
            {"name": "Guernsey", "code": "GG"},
            {"name": "Guinea", "code": "GN"},
            {"name": "Guinea-Bissau", "code": "GW"},
            {"name": "Guyana", "code": "GY"},
            {"name": "Haiti", "code": "HT"},
            {"name": "Heard Island and Mcdonald Islands", "code": "HM"},
            {"name": "Holy See (Vatican City State)", "code": "VA"},
            {"name": "Honduras", "code": "HN"},
            {"name": "Hong Kong", "code": "HK"},
            {"name": "Hungary", "code": "HU"},
            {"name": "Iceland", "code": "IS"},
            {"name": "India", "code": "IN"},
            {"name": "Indonesia", "code": "ID"},
            {"name": "Iran, Islamic Republic Of", "code": "IR"},
            {"name": "Iraq", "code": "IQ"},
            {"name": "Ireland", "code": "IE"},
            {"name": "Isle of Man", "code": "IM"},
            {"name": "Israel", "code": "IL"},
            {"name": "Italy", "code": "IT"},
            {"name": "Jamaica", "code": "JM"},
            {"name": "Japan", "code": "JP"},
            {"name": "Jersey", "code": "JE"},
            {"name": "Jordan", "code": "JO"},
            {"name": "Kazakhstan", "code": "KZ"},
            {"name": "Kenya", "code": "KE"},
            {"name": "Kiribati", "code": "KI"},
            {"name": "Korea, Democratic People's Republic of", "code": "KP"},
            {"name": "Korea, Republic of", "code": "KR"},
            {"name": "Kuwait", "code": "KW"},
            {"name": "Kyrgyzstan", "code": "KG"},
            {"name": "Lao People'S Democratic Republic", "code": "LA"},
            {"name": "Latvia", "code": "LV"},
            {"name": "Lebanon", "code": "LB"},
            {"name": "Lesotho", "code": "LS"},
            {"name": "Liberia", "code": "LR"},
            {"name": "Libyan Arab Jamahiriya", "code": "LY"},
            {"name": "Liechtenstein", "code": "LI"},
            {"name": "Lithuania", "code": "LT"},
            {"name": "Luxembourg", "code": "LU"},
            {"name": "Macao", "code": "MO"},
            {"name": "Macedonia, The Former Yugoslav Republic of", "code": "MK"},
            {"name": "Madagascar", "code": "MG"},
            {"name": "Malawi", "code": "MW"},
            {"name": "Malaysia", "code": "MY"},
            {"name": "Maldives", "code": "MV"},
            {"name": "Mali", "code": "ML"},
            {"name": "Malta", "code": "MT"},
            {"name": "Marshall Islands", "code": "MH"},
            {"name": "Martinique", "code": "MQ"},
            {"name": "Mauritania", "code": "MR"},
            {"name": "Mauritius", "code": "MU"},
            {"name": "Mayotte", "code": "YT"},
            {"name": "Mexico", "code": "MX"},
            {"name": "Micronesia, Federated States of", "code": "FM"},
            {"name": "Moldova, Republic of", "code": "MD"},
            {"name": "Monaco", "code": "MC"},
            {"name": "Mongolia", "code": "MN"},
            {"name": "Montserrat", "code": "MS"},
            {"name": "Morocco", "code": "MA"},
            {"name": "Mozambique", "code": "MZ"},
            {"name": "Myanmar", "code": "MM"},
            {"name": "Namibia", "code": "NA"},
            {"name": "Nauru", "code": "NR"},
            {"name": "Nepal", "code": "NP"},
            {"name": "Netherlands", "code": "NL"},
            {"name": "Netherlands Antilles", "code": "AN"},
            {"name": "New Caledonia", "code": "NC"},
            {"name": "New Zealand", "code": "NZ"},
            {"name": "Nicaragua", "code": "NI"},
            {"name": "Niger", "code": "NE"},
            {"name": "Nigeria", "code": "NG"},
            {"name": "Niue", "code": "NU"},
            {"name": "Norfolk Island", "code": "NF"},
            {"name": "Northern Mariana Islands", "code": "MP"},
            {"name": "Norway", "code": "NO"},
            {"name": "Oman", "code": "OM"},
            {"name": "Pakistan", "code": "PK"},
            {"name": "Palau", "code": "PW"},
            {"name": "Palestinian Territory, Occupied", "code": "PS"},
            {"name": "Panama", "code": "PA"},
            {"name": "Papua New Guinea", "code": "PG"},
            {"name": "Paraguay", "code": "PY"},
            {"name": "Peru", "code": "PE"},
            {"name": "Philippines", "code": "PH"},
            {"name": "Pitcairn", "code": "PN"},
            {"name": "Poland", "code": "PL"},
            {"name": "Portugal", "code": "PT"},
            {"name": "Puerto Rico", "code": "PR"},
            {"name": "Qatar", "code": "QA"},
            {"name": "Reunion", "code": "RE"},
            {"name": "Romania", "code": "RO"},
            {"name": "Russian Federation", "code": "RU"},
            {"name": "RWANDA", "code": "RW"},
            {"name": "Saint Helena", "code": "SH"},
            {"name": "Saint Kitts and Nevis", "code": "KN"},
            {"name": "Saint Lucia", "code": "LC"},
            {"name": "Saint Pierre and Miquelon", "code": "PM"},
            {"name": "Saint Vincent and the Grenadines", "code": "VC"},
            {"name": "Samoa", "code": "WS"},
            {"name": "San Marino", "code": "SM"},
            {"name": "Sao Tome and Principe", "code": "ST"},
            {"name": "Saudi Arabia", "code": "SA"},
            {"name": "Senegal", "code": "SN"},
            {"name": "Serbia and Montenegro", "code": "CS"},
            {"name": "Seychelles", "code": "SC"},
            {"name": "Sierra Leone", "code": "SL"},
            {"name": "Singapore", "code": "SG"},
            {"name": "Slovakia", "code": "SK"},
            {"name": "Slovenia", "code": "SI"},
            {"name": "Solomon Islands", "code": "SB"},
            {"name": "Somalia", "code": "SO"},
            {"name": "South Africa", "code": "ZA"},
            {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
            {"name": "Spain", "code": "ES"},
            {"name": "Sri Lanka", "code": "LK"},
            {"name": "Sudan", "code": "SD"},
            {"name": "Suriname", "code": "SR"},
            {"name": "Svalbard and Jan Mayen", "code": "SJ"},
            {"name": "Swaziland", "code": "SZ"},
            {"name": "Sweden", "code": "SE"},
            {"name": "Switzerland", "code": "CH"},
            {"name": "Syrian Arab Republic", "code": "SY"},
            {"name": "Taiwan, Province of China", "code": "TW"},
            {"name": "Tajikistan", "code": "TJ"},
            {"name": "Tanzania, United Republic of", "code": "TZ"},
            {"name": "Thailand", "code": "TH"},
            {"name": "Timor-Leste", "code": "TL"},
            {"name": "Togo", "code": "TG"},
            {"name": "Tokelau", "code": "TK"},
            {"name": "Tonga", "code": "TO"},
            {"name": "Trinidad and Tobago", "code": "TT"},
            {"name": "Tunisia", "code": "TN"},
            {"name": "Turkey", "code": "TR"},
            {"name": "Turkmenistan", "code": "TM"},
            {"name": "Turks and Caicos Islands", "code": "TC"},
            {"name": "Tuvalu", "code": "TV"},
            {"name": "Uganda", "code": "UG"},
            {"name": "Ukraine", "code": "UA"},
            {"name": "United Arab Emirates", "code": "AE"},
            {"name": "United Kingdom", "code": "GB"},
            {"name": "United States Minor Outlying Islands", "code": "UM"},
            {"name": "Uruguay", "code": "UY"},
            {"name": "Uzbekistan", "code": "UZ"},
            {"name": "Vanuatu", "code": "VU"},
            {"name": "Venezuela", "code": "VE"},
            {"name": "Viet Nam", "code": "VN"},
            {"name": "Virgin Islands, British", "code": "VG"},
            {"name": "Virgin Islands, U.S.", "code": "VI"},
            {"name": "Wallis and Futuna", "code": "WF"},
            {"name": "Western Sahara", "code": "EH"},
            {"name": "Yemen", "code": "YE"},
            {"name": "Zambia", "code": "ZM"},
            {"name": "Zimbabwe", "code": "ZW"}
        ]
    }
};
</script>

<style lang="scss">

.list-payments.list-payments-settings {
    margin-left: 0;
    margin-bottom: 0;
}

.def-card {
    float: right;
    color: #515B65;
}

#remove-credit-card {
    .modal-body {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0;
        .fa-close {
            position: absolute;
            right: 20px;
            top: 20px;
            cursor: pointer;
        }

        img {
            margin: 20px 20px 8px;
        }

        h3 {
            margin: 0 0 20px;
            font-size: 15px;
        }

        p {
            max-width: 400px;
            margin: 0 0 20px;
            text-align: center;
        }

        .control-bar {
            width: 100%;
            display: flex;
            justify-content: center;
            border-top: 0;
            button {
                &:first-child {
                    margin-right: 10px;
                }
            }
        }
    }
}
.stripe-card {
  width: 300px;
  border: 1px solid grey;
}
.stripe-card.complete {
  border-color: green;
}

.modal-content {
    background-color: #fff;
    .modal-header {
        border: 0;
        h5 {
            color: #2f353a;
        }
    }

    .user-details {
        color: #2f353a;
        .add-credit-card-header {
            position: relative;
            h3 {
                margin: 0 0 12px;
                font-size: 15px;
                font-weight: 700;
            }
            .fa-close {
                position: absolute;
                top: 0;
                right: 0;
            }
        }

        h4 {
            font-size: 15px;
            line-height: 20px;
            margin: 0;
        }

        h5 {
            font-size: 10px;
            line-height: 13px;
            margin: 0;
        }

        select {
            margin-top: 10px;
        }

        h3 {
            display: block;
            margin: 35px 0 20px;
            font-size: 15px;
            line-height: 20px;
        }

        label {
            font-size: 12px;
            line-height: 16px;
        }

        .no-mt {
            select {
                margin-top: 0;
            }
        }

        .validate-warning {
            color: red;
        }
    }
}
.modal-footer {
    border: 0;
    display: flex;
    justify-content: space-between;
}
.overview {
    .card-body {
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        > div {

            &.balance {
                h3 {
                    font-size: 32px;
                    font-weight: 700;
                    color: #55cd6c;
                }
            }

            &.list-summary {
                > div {
                    display: flex;
                    justify-content: space-between;
                    margin: 6px 0;

                    em {
                        font-style: normal;
                    }
                }
            }

            &.balance {
                button {
                    margin: 10px 0;
                }
            }
        }
    }
}

.bordered-area {
    padding: 20px;
    border-radius: 5px;
    border: 1px solid #c8ced3;
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }

    .title-area {
        display: block;
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: 700;
    }

    strong {
        display: block;
        margin-bottom: 10px;
    }
}

button.add-payment {
    display: flex;
    align-items: center;
    width: fit-content;
    background-color: #0088ff !important;
    color: #fff;
    box-shadow: none !important;
    border: 0 !important;
    img {
        height: 22px;
        width: auto;
        margin-right: 12px;
    }
    &:hover {
        background-color: #0072cb !important;
        color: #fff !important;
    }
}

.card-body {
    button.add-payment {
        background-color: #0088ff;
        color: #fff;
        i {
            margin-right: 10px;
        }
        &:hover {
            background-color: #0072cb;
        }
    }
}

.list-payments,
.list-mails,
.credit-card-list {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    margin-left: 20px;
    .payment-item,
    .mails-item,
    .card-item {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;

        &.active {
            .icon-select {
                i::before {
                    color: #55cd6c;
                }
            }
        }

        .icon-select {
            width: 5%;
        }
        .card-wrap,
        .mail-wrap {
            border-radius: 5px;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            background-color: #f0f3f5;

            .card-img {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                margin-right: 0;
                margin-left: 0;
                padding: 5px;
                width: 8%;
                min-width: 45px;
            }
            .mail-img {
                padding: 5px;
                width: 10%;
                text-align: center;
            }

            .card-number-settings,
            .mail-address {
                width: 90%;
                color: #23282c;
                em {
                    color: #23282c;
                }
            }

            .edit {
                padding: 7px 0;
                width: 5%;
                border-radius: 0;
                border-left: 2px solid #fff;
                text-align: center;
                cursor: pointer;
            }

            .remove {
                padding: 7px 0;
                width: 5%;
                border-radius: 0;
                border-left: 2px solid #fff;
                text-align: center;
                cursor: pointer;
            }
        }
        .card-wrap {
            padding-left: 0;
        }
    }
}

.credit-card-list {
    .card-item {
        .card-wrap {
            padding: 4px 10px;
            border-radius: 6px;
            color: #ffffff;
            background-color: #f0f3f5;

            .card-number-settings {
                padding-left: 20px;
                color: #23282c;
            }
            span {
                color: #23282c;
            }
        }
    }
}

.refil-wrap {
    display: block;
    > div {
        float: left;
        clear: both;
        display: inline-block;
        padding: 10px;
        margin: 4px 0;
        background-color: #f0f3f5;
        border-radius: 5px;
        &.wrap-enable {
            .switch-label {
                vertical-align: middle;
            }
            > span {
                display: inline-block;
                vertical-align: middle;
                margin-left: 6px;
            }
        }
    }
}

.first-line {
    display: flex;
    flex-direction: row;
    align-items: center;

    .form-control {
        width: 10%;
        margin: 0 10px;
    }
}

.buttom-line {
    margin-top: 10px;
    font-size: 10px;
    color: #515b65;
}

.buttons-wrap {
    margin-bottom: 20px;
}

.buttons-payment-wrap {
    display: flex;
    justify-content: space-between;
    button {
        width: 48%;
    }
}

#add-balance {
    .modal-footer {
        display: none !important;
    }
}

.StripeElement {
    margin-bottom: 20px;
    padding: 10px;
    border-radius: 5px;
    background-color: #f0f3f5;
    border: 1px solid #C9CFD4;
}

#add-credit-card___BV_modal_footer_ {
    padding: 0;
    justify-content: flex-end;
}
.list-payments .payment-item .card-wrap .card-number-settings {
    width: 94%;
    background-color: #f0f3f5;
    padding: 7px 20px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}

.billing-overview {
    .credit-cards-list {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        .credit-card-wrapper {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 10px;

            &:last-child {
                margin-bottom: 0;
            }

            .credit-card {
                max-width: 340px;
                flex-grow: 1;
            }

            .remove-button {
                position: relative;
                height: 36px;
                width: 36px;
                margin-left: 8px;
                box-sizing: border-box;
                text-align: center;
                line-height: 34px;
                border: 1px solid #C9CFD4;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                cursor: pointer;

                .removing-disabled-tooltip {
                    display: none;
                }

                &.removing-disabled {
                    .fa {
                        opacity: 0.2;
                    }

                    &:hover {
                        .removing-disabled-tooltip {
                            position: absolute;
                            top: 50%;
                            left: calc(100% + 10px);
                            min-width: 300px;
                            display: block;
                            color: #fff;
                            padding: 8px 10px;
                            line-height: 1.2;
                            background-color: #241717;
                            -webkit-border-radius: 5px;
                            -moz-border-radius: 5px;
                            border-radius: 5px;
                            z-index: 10;
                        }
                    }
                }
            }

            .set-default-box {
                display: flex;
                align-items: center;
                margin-left: 10px;
                margin-bottom: 10px;

                .set-default {
                    color: #959595;
                    cursor: pointer;

                    &:hover {
                        color: #585858;
                    }
                }

                .default {
                    color: #0072CB;
                }
            }

            .ach-verification-status {
                margin: 0 0 0 12px;
                color: #FC4D4D;
                text-transform: capitalize;
            }

            .ach-verification-remove {
                margin-left: 20px;

                a {
                    color: #0088ff;
                    text-transform: uppercase;
                    font-weight: 700;
                    cursor: pointer;
                }
            }
        }

        .credit-card {
            display: flex;
            align-items: center;
            padding: 4px 20px 4px 4px;
            border: 1px solid #C9CFD4;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            cursor: pointer;

            &.selected {
                border-color: #0088FF;
            }

            .credit-card-image {
                margin-right: 11px;
            }

            .credit-card-number {
                margin-right: 20px;
            }

            .credit-card-nickname {
                color: #959595;
                flex-grow: 1;
                text-align: right;
                text-transform: capitalize;
            }
        }
    }
}

.auto-funds-wrapper {
    .add-row {
        margin: 20px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .first-row,
        .second-row {
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .wrapper-input {
            position: relative;
            margin: 0 10px;
            max-width: 80px;

            &::before {
                content: '$';
                position: absolute;
                top: 7px;
                left: 6px;
            }

            input {
                padding-left: 15px;
            }
        }
    }

    .select-card {
        .card {
            display: flex;
            flex-direction: row;;
            justify-content: flex-start;
            margin: 0;
            border: 0;

            .fts-radio {
                margin-right: 10px;
            }

            strong {
                display: inline-block;
                vertical-align: top;
                margin: 0;
            }
        }
    }

    .buttons-row {
        margin-top: 20px;
    }

    .add-row,
    .select-card,
    .buttons-row {
        &.gray-out {
            position: relative;
            &:before {
                position: absolute;
                content: '';
                top: -10px;
                bottom: -10px;
                left: -20px;
                right: -20px;
                background: rgba(255,255,255,0.5);
                z-index: 10;
            }
        }
    }
}

.dark-theme {
    .list-payments {
        .payment-item {
            border-radius: 5px;
            .card-wrap {
                background-color: transparent;
                .card-number-settings {
                    color: #EDEEEF;
                    background-color: #515b65;
                    .def-card {
                        color: #edeeef;
                    }
                }
                .remove {
                    border-color: #3a4149;
                }
            }
        }
    }
    .btn-outline-success {
        background-color: #515b65;
        color: #EDEEEF;
        &:hover {
            background-color: #55cd6c;
        }
    }


    #add-credit-card {
        .modal-content {
            background-color: #3a4149;

            .user-details {
                color: #EDEEEF;
            }

            .modal-title,
            .close {
                color: #EDEEEF;
            }

            select,
            input {
                background-color: #2f353a;
                border-color: #171a1e;
                color: #EDEEEF;
                &::placeholder {
                    color: #EDEEEF;
                }
            }

            .StripeElement {
                background-color: #2f353a;
                border-color: #171a1e;
                .ElementsApp {
                    input {
                        color: #EDEEEF;
                    }
                }
            }
        }
    }

    #remove-credit-card {
        .user-details {
            color: #EDEEEF;
        }

        .modal-title,
        .close {
            color: #EDEEEF;
        }
    }
    .billing-overview {
        .credit-cards-list {
            display: flex;
            flex-direction: column;

            .credit-card {
                border-color: #1a1c1d;

                .credit-card-nickname {
                    color: #959595;
                }
            }

            .credit-card-wrapper {

                .remove-button {
                    border-color: #1a1c1d;
                }

                .set-default-box {
                    .set-default {
                        color: #959595;

                        &:hover {
                            color: #D6D6D6;
                        }
                    }

                    .default {
                        color: #ffffff;
                    }
                }
            }
        }
    }
    .bordered-area {
        border-color: #1a1c1d;
    }

    .auto-funds-wrapper {


        .add-row,
        .select-card,
        .buttons-row {
            &.gray-out {
                position: relative;
                &:before {
                    background: rgba(58, 65, 73,0.5);
                }
            }
        }
    }
    #addAchAccount___BV_modal_body_ {
        .ach-account-wrap {
            .ach-account-header {
                h3 {
                    color: #fff;
                }
            }
            .ach-account-body {
                span {
                    color: #fff;
                }
                .form-group {
                    input {
                        color: #fff;
                        background-color: #515b65;
                        border-color: #1a1c1d;
                        &::placeholder {
                            color: #fff;
                        }
                    }
                }
            }
        }
    }

    #summaryAchAccount___BV_modal_body_ {
        .ach-account-wrap {
            .ach-account-header {
                h3 {
                    color: #fff;
                }
            }
            .ach-account-body {
                span {
                    color: #fff;
                }
                .ach-data {
                    .field {
                        .label {
                            color: #fff;
                        }
                    }
                }
                .ach-error {
                    background-color: #6b3d3d;
                    color: #fff;
                    h3 {
                        color: #fff;
                    }
                }
                .ach-warning {
                    p {
                        color: #000;
                    }
                }
            }
        }
    }
    .ach-area {
        .ach-pin {
            color: #fff;
            background-color: #515b65;
            border-color: #1a1c1d;
            &::placeholder {
                color: #fff;
            }
        }
    }
}

.wrong-dollar {
    margin-bottom: 10px;
}
.wrong-diffrence {
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 18px;

    strong {
        display: inline-block;
        vertical-align: top;
        margin: 0;
        font-size: 14px;
        line-height: 18px;
    }
}

.billing-overview {
    .card-header {
        display: flex;
        justify-content: space-between;

        .btn-link {
            padding: 0;
            font-weight: 700;
            font-size: 15px;
            color: #0088FF;
            text-transform: uppercase;

        }
    }
}

.ach-account-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    h3 {
        font-size: 15px;
        color: #2F353A;
    }

    button {
        margin: 0;
        background-color: transparent;
        border: 0;
        text-align: center;

        i {
            margin: 0;
        }
    }
}

.ach-account-body {
    span:nth-child(1) {
        display: block;
        margin-bottom: 20px;
        text-align: left;
        font-size: 14px;
        color: #2F353A;
    }
    .validate-warning {
        color: red;
    }

    .ach-account-error {
        margin-bottom: 20px;
        color: red;
    }

    .validate-warning {
        text-align: left;
        margin: 0;
    }

    .ach-data {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        .field {
            width: 37%;
            margin-right: 3%;
            margin-bottom: 20px;

            span {
                display: block;
                margin: 0 0 4px;
                font-size: 14px;
                line-height: 24px;
                text-align: left;
            }

            strong {
                display: block;
                font-size: 14px;
                line-height: 24px;
            }
        }

        .field-x2 {
            width: 57%;
        }

        .field-x05 {
            width: 10%;
            margin-right: 0;
        }


    }

    span {
        display: block;
        font-size: 12px;
        line-height: 20px;
        color: #515B65;
        text-align: center;
    }
}

.ach-account-buttons {
    display: flex;
    justify-content: flex-end;

    button {
        margin-left: 10px;
    }
}

#summaryAchAccount {
    .ach-account-buttons {
        margin-top: 20px;
        justify-content: space-between;
    }
}

.ach-error {
    padding: 20px;
    margin-bottom: 10px;
    background-color: #FFE3E3;
    border: 1px solid #FC4D4D;
    border-radius: 5px;

    h3 {
        display: block;
        margin: 0;
        font-size: 14px;
        line-height: 24px;
        text-transform: uppercase;
        font-weight: 700;
        color: #2F353A;
    }

    p {
        display: block;
        margin: 0;
        font-size: 14px;
        line-height: 24px;
    }
}

.ach-warning {
    padding: 20px;
    margin-bottom: 10px;
    background-color: #FFFAE3;
    border: 1px solid #FFC400;
    border-radius: 5px;

    h3 {
        display: block;
        margin: 0;
        font-size: 14px;
        line-height: 24px;
        text-transform: uppercase;
        font-weight: 700;
        color: #2F353A;
    }

    p {
        display: block;
        margin: 0;
        font-size: 14px;
        line-height: 24px;
    }
}

.ach-validation {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, .7);
}

.ach-area {
    strong {
        margin: 0 0 10px;
    }

    .btn-pay {
        margin-bottom: 20px;
    }

    .list-payments-settings {
        margin-bottom: 20px;
    }

    .credit-cards-list {
        margin: 0;
    }

    .verification-info {
        margin-bottom: 20px;
    }

    .ach-verification {
        margin-left: 8px;
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
    }

    .pin-1,
    .pin-2 {
        margin-right: 8px;
    }

    .ach-pin {
        height: 36px;
        width: 100px;
        padding: 0 0 0 18px;
        font-size: 13px;
        line-height: 36px;
        background-color: #F0F3F5;
        border: 1px solid #C9CFD4;
        border-radius: 5px;
        text-align: center;
        box-sizing: border-box;
        outline: none;
    }

    .credit-cards-list .credit-card {
        box-shadow: none;
    }

    .remove-button {
        box-shadow: none !important;
    }
    .add-ach-btn {
        display: flex;
        align-items: center;
        img {
            height: 22px;
            width: auto;
            margin-right: 12px;
        }
    }
}

.list-payments-settings {
    .credit-card {
        // box-shadow: none;
        .ach-logo {
            padding: 6px 8px;
            margin-right: 10px;
            display: inline-block;
            background-color: #00C4B0;
            border-radius: 4px;
            font-size: 11px;
            line-height: 13px;
            font-weight: 700;
            color: #fff;
        }
    }
}

</style>
